module.exports = __webpack_public_path__ + "img/sidebar-battery-0.012c6ef6.svg";